import { handleActions } from 'redux-actions';

import { setCart } from '../actions';

import handleSetCart from './handleSetCart';

export default handleActions(
    {
        [setCart]: handleSetCart,
    },
    {
        cart: null,
    },
);
